import React from 'react';
export function SocialMediaVideosSlide() {
  const platforms = [{
    name: 'Instagram',
    handle: '@explorandoconfran',
    url: 'https://www.instagram.com/explorandoconfran/',
    icon: <svg className="h-6 w-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-1364">
          <rect x="2" y="2" width="20" height="20" rx="5" ry="5" data-id="element-1365"></rect>
          <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" data-id="element-1366"></path>
          <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" data-id="element-1367"></line>
        </svg>,
    videos: [{
      thumbnail: 'https://uploadthingy.s3.us-west-1.amazonaws.com/1FDpwtwTEYbrtszq7NPZgo/image.png',
      title: 'Playa Linda',
      views: '12.5K',
      likes: '843',
      duration: '00:30'
    }, {
      thumbnail: 'https://images.unsplash.com/photo-1590001155093-a3c66ab0c3ff?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80',
      title: 'Holiday Inn Aruba',
      views: '9.2K',
      likes: '721',
      duration: '00:20'
    }]
  }, {
    name: 'TikTok',
    handle: '@explorandoconfran',
    url: 'https://www.tiktok.com/@explorandoconfran',
    icon: <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/if4RacDtbfddqkvrotpJLk/tiktok-logo-thin.svg" alt="TikTok logo" className="h-6 w-6" data-id="element-1368" />,
    videos: [{
      thumbnail: 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?ixlib=rb-4.0.3&auto=format&fit=crop&w=1170&q=80',
      title: 'Holiday Inn Time Lapse',
      views: '299K',
      likes: '23K',
      duration: '00:30'
    }, {
      thumbnail: 'https://images.unsplash.com/photo-1590523741831-ab7e8b8f9c7f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1074&q=80',
      title: 'Playa Linda',
      views: '154K',
      likes: '12.7K',
      duration: '00:30'
    }]
  }, {
    name: 'YouTube',
    handle: '@explorandoconfran',
    url: 'https://www.youtube.com/@explorandoconfran',
    icon: <svg className="h-6 w-6" viewBox="0 0 24 24" fill="currentColor" data-id="element-1369">
          <path d="M19.615 3.184c-3.604-.246-11.631-.245-15.23 0-3.897.266-4.356 2.62-4.385 8.816.029 6.185.484 8.549 4.385 8.816 3.6.245 11.626.246 15.23 0 3.897-.266 4.356-2.62 4.385-8.816-.029-6.185-.484-8.549-4.385-8.816zm-10.615 12.816v-8l8 3.993-8 4.007z" data-id="element-1370" />
        </svg>,
    videos: [{
      thumbnail: 'https://images.unsplash.com/photo-1590622783586-e95526e3a8bd?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80',
      title: 'Holiday Inn Time Lapse',
      views: '8.7K',
      likes: '432',
      duration: '00:30'
    }, {
      thumbnail: 'https://images.unsplash.com/photo-1590001155093-a3c66ab0c3ff?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80',
      title: 'Holiday Inn Aruba',
      views: '5.3K',
      likes: '289',
      duration: '00:20'
    }]
  }];
  return <div className="w-full bg-white" data-id="element-1371">
      <div className="max-w-5xl mx-auto" data-id="element-1372">
        <div className="mb-10" data-id="element-1373">
          <h2 className="text-2xl font-normal text-black mb-6" data-id="element-1374">
            Mis Videos en Redes Sociales
          </h2>
          <p className="text-base text-gray-700 mb-8 leading-relaxed" data-id="element-1375">
            Explora una selección de mis mejores contenidos en diferentes
            plataformas. Cada red social tiene su propio estilo y audiencia,
            permitiéndome conectar con diferentes comunidades de viajeros y
            amantes de la naturaleza.
          </p>
        </div>
        <div className="space-y-12" data-id="element-1376">
          {platforms.map((platform, index) => <div key={index} className="bg-gray-50 p-6 rounded-lg" data-id="element-1377">
              <div className="flex items-center mb-6" data-id="element-1378">
                <div className="mr-3" data-id="element-1379">{platform.icon}</div>
                <div data-id="element-1380">
                  <h3 className="text-xl font-normal text-black" data-id="element-1381">
                    {platform.name}
                  </h3>
                  <a href={platform.url} target="_blank" rel="noopener noreferrer" className="text-sm text-gray-600 hover:text-black transition-colors" data-id="element-1382">
                    {platform.handle}
                  </a>
                </div>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-1383">
                {platform.videos.map((video, vidIndex) => <div key={vidIndex} className="bg-white rounded-lg overflow-hidden shadow-sm" data-id="element-1384">
                    <div className="aspect-video relative" data-id="element-1385">
                      <img src={video.thumbnail} alt={video.title} className="w-full h-full object-cover" data-id="element-1386" />
                      <div className="absolute inset-0 flex items-center justify-center" data-id="element-1387">
                        <div className="w-12 h-12 rounded-full bg-black/50 flex items-center justify-center" data-id="element-1388">
                          <div className="w-0 h-0 border-t-[8px] border-t-transparent border-l-[16px] border-l-white border-b-[8px] border-b-transparent ml-1" data-id="element-1389"></div>
                        </div>
                      </div>
                      <div className="absolute bottom-3 right-3 bg-black/50 text-white text-xs px-2 py-1 rounded" data-id="element-1390">
                        {video.duration}
                      </div>
                    </div>
                    <div className="p-4" data-id="element-1391">
                      <h4 className="text-base font-medium text-black mb-2" data-id="element-1392">
                        {video.title}
                      </h4>
                      <div className="flex justify-between text-sm text-gray-600" data-id="element-1393">
                        <span data-id="element-1394">{video.views} visualizaciones</span>
                        <span data-id="element-1395">{video.likes} likes</span>
                      </div>
                    </div>
                  </div>)}
              </div>
              <div className="mt-4 text-center" data-id="element-1396">
                <a href={platform.url} target="_blank" rel="noopener noreferrer" className="text-sm text-black hover:text-gray-700 transition-colors inline-flex items-center" data-id="element-1397">
                  Ver más en {platform.name}
                  <svg className="w-4 h-4 ml-1" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-1398">
                    <path d="M5 12h14" data-id="element-1399"></path>
                    <path d="M12 5l7 7-7 7" data-id="element-1400"></path>
                  </svg>
                </a>
              </div>
            </div>)}
        </div>
      </div>
    </div>;
}